import { deleteJson, getJson, postJson } from './client'
import type { LandscapeGoal, LandscapeView } from '../types/landscape'

// The Digital Landscape: what can be connected, what is, the firm's goals, and which screens exist
// for this person. The API decides unlock state; the browser only renders it (404-not-403).
const landscape = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout/landscape`

export const landscapeApi = {
  get: (spoke: string) => getJson<LandscapeView>(landscape(spoke)),
  addGoal: (spoke: string, title: string, detail: string, dependsOn: string[]) =>
    postJson<LandscapeGoal>(`${landscape(spoke)}/goals`, { title, detail, dependsOn }),
  removeGoal: (spoke: string, id: string) => deleteJson<void>(`${landscape(spoke)}/goals/${encodeURIComponent(id)}`),
}
